<link rel="ractive" href="../../r-page-globalping.html" name="r-page">
<link rel="ractive" href="../../components/gp-header.html" name="c-gp-header">
<link rel="ractive" href="../../components/gp-footer.html" name="c-gp-footer">
<link rel="ractive" href="../../components/notification.html" name="c-notification">
<link rel="ractive" href="../../components/gp-jumbotron.html" name="c-gp-jumbotron">
<link rel="ractive" href="../../components/range-slider.html" name="c-range-slider">

<r-page noYield="{{noYield}}" title="{{title}}" description="{{description}}">
	<c-notification></c-notification>

	<c-gp-header additionalClasses="header-with-gp-translucent-bg"></c-gp-header>

	<div class="p-globalping-credits">
		<c-gp-jumbotron className="credits" gridType="type4"></c-gp-jumbotron>

		<div class="gp-credits">
			<div class="gp-credits_info">
				<h1 class="gp-credits_info_title">Globalping limits and credits</h1>

				<div class="gp-credits_info_descr">
					Start using Globalping for free - no registration needed!
				</div>

				<div class="gp-credits_info_user-benefits">
					<div class="gp-credits_info_user-benefits_block">
						<span class="gp-credits_info_user-benefits_block_title">Unregistered User</span>

						<div class="gp-credits_info_user-benefits_block_list">
							<span class="gp-credits_info_user-benefits_block_list_item">
								<img width="20"
									height="20"
									src="{{@shared.assetsHost}}/img/globalping/check.svg"
									loading="lazy">

								<span class="gp-credits_info_user-benefits_block_list_item_numbers">
									{{this.userBenefits.unregistered.probesPerMeas}}
								</span>

								<span class="gp-credits_info_user-benefits_block_list_item_text">Probes per measurement</span>
							</span>

							<span class="gp-credits_info_user-benefits_block_list_item">
								<img width="20"
									height="20"
									src="{{@shared.assetsHost}}/img/globalping/check.svg"
									loading="lazy">

								<span class="gp-credits_info_user-benefits_block_list_item_numbers">
									{{this.userBenefits.unregistered.freeTestsPerHour}}
								</span>

								<span class="gp-credits_info_user-benefits_block_list_item_text">Free tests per hour</span>
							</span>
						</div>
					</div>

					<div class="gp-credits_info_user-benefits_block registered">
						<span class="gp-credits_info_user-benefits_block_title">Registered User</span>

						<div class="gp-credits_info_user-benefits_block_list">
							<span class="gp-credits_info_user-benefits_block_list_item">
								<img width="20"
									height="20"
									src="{{@shared.assetsHost}}/img/globalping/check.svg"
									loading="lazy">
								<span class="gp-credits_info_user-benefits_block_list_item_numbers">{{this.userBenefits.registered.probesPerMeas}}</span>
								<span class="gp-credits_info_user-benefits_block_list_item_text">Probes per measurement</span>
							</span>

							<span class="gp-credits_info_user-benefits_block_list_item">
								<img width="20"
									height="20"
									src="{{@shared.assetsHost}}/img/globalping/check.svg"
									loading="lazy">
								<span class="gp-credits_info_user-benefits_block_list_item_numbers">{{this.userBenefits.registered.freeTestsPerHour}}</span>
								<span class="gp-credits_info_user-benefits_block_list_item_text">Free tests per hour</span>
							</span>
						</div>

						<span class="gp-credits_info_user-benefits_block_hint">
							<span>Higher limits for members!</span>
							<img as-tooltip="[ 'By creating a free account you help us fight abuse while getting access to higher limits and additional features.' ], 'top', undefined, undefined, 'multiline gp-credits_tooltip'"
								width="14"
								height="14"
								src="{{@shared.assetsHost}}/img/globalping/help-icon.svg">
						</span>
					</div>
				</div>

				<div class="gp-credits_info_credits-donations">
					<c-range-slider></c-range-slider>
				</div>
			</div>

			<div class="gp-credits_become-a-sponsor">
				<img class="gp-credits_become-a-sponsor_polygons left"
					width="510"
					height="289"
					src="{{@shared.assetsHost}}/img/globalping/credits/polygons_1.svg"
					loading="lazy">

				<img class="gp-credits_become-a-sponsor_polygons right"
					width="362"
					height="288"
					src="{{@shared.assetsHost}}/img/globalping/credits/polygons_2.svg"
					loading="lazy">

				<div class="gp-credits_become-a-sponsor_block left">
					<h2 class="gp-credits_become-a-sponsor_block_title">Become a sponsor</h2>

					<h3 class="gp-credits_become-a-sponsor_block_subtitle">+2000 tests per $1 donated</h3>

					<div class="gp-credits_become-a-sponsor_block_content">
						We aim to offer a reliable service to everyone,
						from home users and solo developers to startups, corporations, and large enterprises.
						We're doing our best to keep things fair. Everyone gets a number of free requests every hour,
						while larger users may pay for additional requests, and help support the active development of the project.
					</div>

					<a target="_blank"
						href="https://github.com/sponsors/jsdelivr"
						class="gp_btn_green gp-credits_become-a-sponsor_block_btn">
						Become a GitHub sponsor
					</a>
				</div>

				<div class="gp-credits_become-a-sponsor_block right">
					<h2 class="gp-credits_become-a-sponsor_block_title">Host a probe</h2>

					<h3 class="gp-credits_become-a-sponsor_block_subtitle">+150 tests/probe/day</h3>

					<div class="gp-credits_become-a-sponsor_block_content">
						Generate free credits passively!
						Become a member of the community by hosting a probe and adopting it under your account.
						For each day your probe stays online, you will get additional free credits.
					</div>

					<a class="gp_btn_green gp-credits_become-a-sponsor_block_btn"
						on-click="@this.openLink(@shared.serverHost + '/#join-the-network')">
						Host a probe
					</a>
				</div>
			</div>

			<div class="gp-credits_faq">
				<h2 class="gp-credits_faq_title">Frequently Asked Questions</h2>
				<span class="gp-credits_faq_descr"></span>

				<div class="gp-credits_faq_list">
					{{#each faq}}
						<div class="gp-credits_faq_list_item">
							<span class="gp-credits_faq_list_item_question">{{this.question}}</span>
							<span class="gp-credits_faq_list_item_answer">{{{this.answer}}}</span>
						</div>
					{{/each}}
				</div>
			</div>
		</div>
	</div>

	<c-gp-footer></c-gp-footer>
</r-page>

<script>
	const tooltip = require('../../../assets/js/decorators/tooltip');

	component.exports = {
		decorators: {
			tooltip,
		},
		data () {
			return {
				title: 'Credits - Globalping',
				description: 'Start using Globalping for free - no registration needed! Get higher limits by creating an account, hosting probes, or sponsoring the project.',
				userBenefits: {
					unregistered: {
						probesPerMeas: 50,
						freeTestsPerHour: 250,
					},
					registered: {
						probesPerMeas: 500,
						freeTestsPerHour: 500,
					},
				},
				faq: [
					{
						question: 'How to generate free credits?',
						answer: 'Simply login to the <a href="https://dash.globalping.io" target="_blank">Globalping Dashboard</a> and follow the instructions. You will need to host a probe using a Docker container or by ordering our hardware probe.',
					},
					{
						question: 'What is a credit and what does it do?',
						answer: 'A single credit equals to one test. For example if you request a ping measurement from 5 locations, it will use 5 credits. A single measurement can request up to 500 probes, which effectively means a maximum of 500 credits being used per measurement.',
					},
					{
						question: 'How to buy more credits?',
						answer: 'You will need to register an account first and then donate your chosen amount using GitHub Sponsors. Our system will pick up the donation and credit your account automatically.',
					},
					{
						question: 'Can I use credits to power a commercial tool or product?',
						answer: 'Yes, we support commercial use of Globalping within the limits of our terms of service.',
					},
					{
						question: 'Do you support non-profits with free credits?',
						answer: 'Yes, we can provide large amounts of free credits to all kinds of organizations and projects after a manual review. Please contact us via email.',
					},
					{
						question: 'How to get in contact?',
						answer: 'To report issues with the API or our tools it is best to open a GitHub issue. But if for any reason you prefer to contact us privately via email you can do so at <a href="mailto:d@globalping.io">d@globalping.io</a>',
					},
				],
			};
		},
		openLink (url) {
			event.preventDefault();
			window.open(url, '_blank');
		},
	};
</script>
